import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

export const InfoBubbleDiv = styled.div`
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  animation: 150ms fadeIn ease-in-out forwards;
`;
